import type { Controller } from "./index";

export class AbstractCmdController {
  readonly controller: Controller;

  constructor(controller: Controller) {
    this.controller = controller;
  }
}
